import React from 'react'
import { ProjectFilterContextType } from './ProjectFilterContextProvider'

export const ProjectFilterContext =
  React.createContext<ProjectFilterContextType>(null)
